import axios from "axios";
import { BASE_API_URL } from "../constants";

export function apiCall(method, path, data, options) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common["Authorization"] = localStorage.apiToken;
    return axios[method.toLowerCase()](`${BASE_API_URL}${path}`, data, options)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err.response);
      });
  });
}

export function externalApiCall(method, path, data, options) {
  return new Promise((resolve, reject) => {
    return axios[method.toLowerCase()](`${path}`, data, options)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err.response);
      });
  });
}
